export const INSERT_PM_FORM_MUTATION = `
  mutation InsertPmForm($input: PmFormInsertInput!) {
    insertPmForm(input: $input) {
      itemId
      totalImpactedData
      acknowledged
    }
  }
`;

export const UPDATE_PM_FORM_MUTATION = `
  mutation UpdatePmForm($filter: String!, $input: PmFormUpdateInput!) {
    updatePmForm(filter: $filter, input: $input) {
      itemId
      totalImpactedData
      acknowledged
    }
  }
`;

export const DELETE_PM_FORM_MUTATION = `
  mutation DeletePmForm($filter: String!, $input: PmFormDeleteInput!) {
    deletePmForm(filter: $filter, input: $input) {
      acknowledged
      totalImpactedData
    }
  }
`;
